import { createSubstore } from 'storeon-substore';
import type { Store } from 'store/types';
import { MOSCOW } from 'common/constants/region-codes';
import { requestSitemap } from './sitemap-actions';
import { FETCH_SITEMAP, SITEMAP_STORE_NAME } from './sitemap-constants';
import { SitemapStore } from './sitemap-types';

const INITIAL_STATE: SitemapStore = {
  pageList: null,
  error: null,
  loading: false,
} as const;

const PAGES = ['/catalogue/', '/rooms/', '/uslugi/'];

export const sitemap = (parentStore: Store) => {
  const store = createSubstore(parentStore, SITEMAP_STORE_NAME);
  store.on('@init', () => INITIAL_STATE);
  store.on(FETCH_SITEMAP.init, async () => {
    const { loading } = store.get();
    const { modelJson, orchestratorHost, useCredentials, apiKey, requestID } = parentStore.get();

    if (!modelJson.model || loading) {
      return Promise.resolve();
    }

    store.dispatch(FETCH_SITEMAP.request);

    const config = {
      orchestratorHost,
      useCredentials,
      apiKey,
      requestID,
    };

    try {
      const rootPages = await Promise.all(PAGES.map(page => requestSitemap(modelJson.model?.properties?.regionId || MOSCOW, page, 1, config)));

      const pageList = [];
      for (let i = 0; i < rootPages.length; i++) {
        const { totalPage, pages } = rootPages[i];

        const fnArray = [];
        for (let j = 2; j <= totalPage; j++) {
          fnArray.push(() => requestSitemap(modelJson.model?.properties?.regionId || MOSCOW, PAGES[i], j, config));
        }

        const structure = [];
        let step = 10;
        for (let j = 0; j < fnArray.length;) {
          const chunkResult = await Promise.all(fnArray.slice(j, j + step).map(fn => fn()));
          structure.push(...chunkResult);
          j += step;
        }

        const result = [...pages];
        for (let index = 0; index < structure.length; index++) {
          result.push(...structure[index].pages);
        }

        pageList.push(...result);
      }

      store.dispatch(FETCH_SITEMAP.success, pageList);
    } catch (e) {
      store.dispatch(FETCH_SITEMAP.failure, JSON.stringify(e));
    }

    return Promise.resolve();
  });
  store.on(FETCH_SITEMAP.request, state => ({ ...state, loading: true }))
  store.on(FETCH_SITEMAP.failure, (state, error) => ({ ...state, error, loading: false }));
  store.on(FETCH_SITEMAP.success, (state, res) => ({ ...state, pageList: res, loading: false }));
};
